import { RouteComponentProps } from "react-router-dom";
import { RouteOnboardingRequirementDetailsContent } from "./RouteOnboardingRequirementDetailsContent";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../../query/WSQuery";
import { useRequirementQuery } from "../../../../../query/requirements/queries/useRequirementQuery";

export const RouteOnboardingRequirementDetails: React.FC<
  RouteComponentProps<{
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId }
  }
}) => {
  const queryRequirement = useRequirementQuery(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryRequirement
        }}
      >
        {({ queryRequirementData }) => {
          return (
            <RouteOnboardingRequirementDetailsContent
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
